import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-67879844"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "location" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "top" }, [
  /*#__PURE__*/_createElementVNode("p", null, "我的消息"),
  /*#__PURE__*/_createElementVNode("div", { class: "black" }),
  /*#__PURE__*/_createElementVNode("div")
], -1))
const _hoisted_3 = ["onClick"]
const _hoisted_4 = {
  key: 0,
  class: "red"
}
const _hoisted_5 = {
  key: 1,
  class: "system"
}
const _hoisted_6 = {
  key: 2,
  class: "system"
}
const _hoisted_7 = {
  key: 3,
  class: "system"
}
const _hoisted_8 = {
  key: 4,
  class: "system"
}
const _hoisted_9 = {
  key: 5,
  class: "system"
}
const _hoisted_10 = {
  key: 6,
  class: "system"
}
const _hoisted_11 = { key: 7 }
const _hoisted_12 = { class: "time" }
const _hoisted_13 = { class: "content" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Lack = _resolveComponent("Lack")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    (_ctx.userMessage.data.length == 0 && _ctx.userMessage.data.length < 1)
      ? (_openBlock(), _createBlock(_component_Lack, { key: 0 }))
      : _createCommentVNode("", true),
    (_ctx.userMessage.data.length && _ctx.userMessage.data.length > 0)
      ? (_openBlock(true), _createElementBlock(_Fragment, { key: 1 }, _renderList(_ctx.userMessage.data, (item, index) => {
          return (_openBlock(), _createElementBlock("div", {
            class: "text",
            key: index,
            onClick: ($event: any) => (_ctx.changeStatus(index))
          }, [
            _createElementVNode("div", {
              class: _normalizeClass(["inform", { texts: item.status == 1 }])
            }, [
              (_ctx.userMessage.data[index].status == 0)
                ? (_openBlock(), _createElementBlock("div", _hoisted_4))
                : _createCommentVNode("", true),
              (item.type == 1)
                ? (_openBlock(), _createElementBlock("div", _hoisted_5, "【个人认证】"))
                : _createCommentVNode("", true),
              (item.type == 2)
                ? (_openBlock(), _createElementBlock("div", _hoisted_6, "【企业认证】"))
                : _createCommentVNode("", true),
              (item.type == 3)
                ? (_openBlock(), _createElementBlock("div", _hoisted_7, "【作品审核】"))
                : _createCommentVNode("", true),
              (item.type == 4)
                ? (_openBlock(), _createElementBlock("div", _hoisted_8, "【提现进度】"))
                : _createCommentVNode("", true),
              (item.type == 5)
                ? (_openBlock(), _createElementBlock("div", _hoisted_9, "【开票进度】"))
                : _createCommentVNode("", true),
              (item.type == 6)
                ? (_openBlock(), _createElementBlock("div", _hoisted_10, "【营销活动】"))
                : _createCommentVNode("", true),
              (item.title != null)
                ? (_openBlock(), _createElementBlock("p", _hoisted_11, _toDisplayString(item.title), 1))
                : _createCommentVNode("", true),
              _createElementVNode("div", _hoisted_12, _toDisplayString(_ctx.mday(index)), 1),
              _createElementVNode("div", _hoisted_13, _toDisplayString(item.content), 1)
            ], 2)
          ], 8, _hoisted_3))
        }), 128))
      : _createCommentVNode("", true)
  ]))
}